module.exports = __webpack_public_path__ + "img/elec-transformer.7dda46cf.jpg";